/**
 * Snap Sight: the gun comes up faster.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const SNAP_SIGHT = {
  id: 'snapSight',
  branch: 'gunplay',
  tier: 2,
  title: 'Snap Sight',
  blurb: 'A brisk, cheerful presentation of the weapon. Smile optional.',
  maxRanks: 3,
  minLevel: 9,
  requires: ['brassDiscipline'],
  statGrants: {},
  effects: [{ field: 'adsSeconds', perRank: -0.08, condition: null }],
  damageModifiers: [],
} as const satisfies Perk;
